import Immutable from 'immutable';
import { getRegion } from '../app/regions';

export const UPDATE_ORDER = 'takeback/order/UPDATE_ORDER';
export const RESET_ORDER = 'takeback/order/RESET_ORDER';
export const DISPATCH_ORDER = 'takeback/order/DISPATCH_ORDER';
export const DISPATCH_ORDER_SUCCESS = 'takeback/order/DISPATCH_ORDER_SUCESS';
export const DISPATCH_ORDER_FAILURE = 'takeback/order/DISPATCH_ORDER_FAILURE';
export const STATE_DISPATCHED_FAILURE = 'dispatched_failure';
export const STATE_DISPATCHED_SUCCESS = 'dispatched_success';
export const STATE_NEW = 'new';


const initialState = Immutable.fromJS({
    location: null,
    positions: {},
    additions: {},
    region: null,
    service: null,
    state: STATE_NEW,
});

/* Reducers */
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case UPDATE_ORDER:
        /* eslint-disable no-case-declarations */
        let order = action.payload;

        order.get('positions').forEach((pos, i) => {
            if (!pos.count()) {
                order = order.removeIn(['positions', i]);
            }
        });

        return order;

    case RESET_ORDER: {

        return initialState;
    }

    case DISPATCH_ORDER_SUCCESS:
        return state
            .mergeDeep(action.order)
            .set('state', STATE_DISPATCHED_SUCCESS);

    case DISPATCH_ORDER_FAILURE:
        return state.set('state', STATE_DISPATCHED_FAILURE);

    default: return state;
    }
}

/* Selectors */
export function getOrder(state) {
    return state.order;
}

export function getCurrentRegion(state) {
    return getRegion(state, state.order.get('region'));
}

/* Transforms */

export function transformForApiRequest(order) {
    if (!Immutable.Map.isMap(order)) {
        throw new TypeError(`Order is of invalid type, expected Immutable.Map`);
    }

    const result = {
        location_id: order.get('location'),
        region_id: order.get('region'),
        service_id: order.get('service'),
        additions: order.get('additions').toJS(),
        positions: [],
    };

    // TODO: Why the heck is the data structure so damn complicated?
    order.get('positions').forEach((position, serviceId) => {
        position.forEach((count, productId) => {
            result.positions.push({
                service_id: serviceId,
                product_id: productId,
                count,
            });
        });
    });

    return result;
}

export function transformForDispatch(order) {
    return transformForApiRequest(order);
}

/* Actions */
export function updateOrder(payload) {
    return {
        type: UPDATE_ORDER,
        payload,
    };
}

export function resetOrder() {
    return { type: RESET_ORDER };
}

export function dispatchOrder(order) {
    return {
        type: DISPATCH_ORDER,
        order,
    };
}

export function dispatchSuccess(order) {
    return {
        type: DISPATCH_ORDER_SUCCESS,
        order,
    };
}

export function dispatchFailure(order, error) {
    return {
        type: DISPATCH_ORDER_FAILURE,
        order,
        error,
    };
}
